import { getEnvironmentConfigSync } from './config/environment';

const envConfig = getEnvironmentConfigSync();

let Config = {
    ONESIGNAL_API_URL: envConfig.ONESIGNAL_CONFIG.apiUrl,
    ONESIGNAL_APP_ID: envConfig.ONESIGNAL_CONFIG.appId,
    ONESIGNAL_Authorization: envConfig.ONESIGNAL_CONFIG.authorization,
    ONESIGNAL_GROUP: envConfig.ONESIGNAL_CONFIG.groupSize
}

export {Config}


// WEBPACK FOOTER //
// ./src/config.js